import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
gsap.registerPlugin(ScrollTrigger, SplitText)

export const initAnimation = () => {
  bannerHomepage()
	bannerBackground()
  drawText()
}

const bannerHomepage = () => {
	const banner = document.querySelector('.banner')

	if (!banner || window.isLivePreview) return 

	const header = document.querySelector('.header')
	const lines = banner.querySelectorAll('.line')
	const text = banner.querySelector('.banner__text')
	
	const tl = gsap.timeline({
		delay: window.initialLoad ? 1 : 0
	})

	tl.fromTo(lines, {
		yPercent: 108
	}, {
		yPercent: 0,
		duration: 1.6,
		stagger: 0.1,
		ease: 'expo',
	})

	tl.fromTo(text, {
		y: 40,
		opacity: 0
	}, {
		y: 0,
		opacity: 1,
		duration: 1,
		stagger: 0.1,
		ease: 'power2',
		clearProps: 'all'
	}, '-=1.4')

	if (window.initialLoad) {
		tl.fromTo(header, {
			yPercent: -100
		}, {
			yPercent: 0,
			duration: 1.2,
			ease: 'expo',
			clearProps: 'all'
		}, '-=1.2')
	}
}

const bannerBackground = () => {
	const banner = document.querySelector('.banner')

	if (!banner || window.isLivePreview) return

	const background = banner.querySelector('.banner__background')

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: background,
			pin: true,
			endTrigger: '.services',
			start: 'top top',
			end: 'bottom top',
			scrub: true
		}
	})
	
	tl.fromTo(background, {
		opacity: 1
	}, {
		opacity: 0,
		duration: 1,
		ease: 'power2',
	})
}

const drawText = () => {

  const els = document.querySelectorAll('[data-draw-text]')

  if (!els.length || window.innerWidth < 1024) return false

  document.fonts.ready.then(() => {
    els.forEach(el => {

      let split = new SplitText(el, {
        type: 'lines',
      })

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: 'bottom 70%',
          // markers: true,
        }
      })

      split.lines.forEach(line => {
        tl.fromTo(line, {
          clipPath: 'polygon(0 -15%, 0 -15%, 0 115%, 0 115%)',
        }, {
          clipPath: 'polygon(0 -15%, 100% -15%, 100% 115%, 0 115%)',
        })
      })

    })
  })
}

export default () => { }